<!--请求历史未接收上报数据接口-->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "startTime": "20181022000000",
	"endTime": "20181022235959",
	"dataType": 0,
	"pageNum": 1,
	"pageSize": 10
           },
            responseCode: {"data": {
                "total": 1,
		"currCount": 1,
		"recordInList": [{
			"data": {
				"enterVipType": 1,
				"enterChannelCode": "0001",
				"enterSpeed": 0,
				"inOperatorTime": "20181022190627",
				"enterCarLicenseNumber": "粤J20846",
				"enterStatisticalArea": "0",
				"inOperatorName": "System",
				"enterCustomVipName": "",
				"remark": "",
				"enterCarLicenseColor": 0,
				"enterCarColor": 0,
				"correctType": 0,
				"enterTime": "20181022190627",
				"enterNovipCode": 1,
				"enterImageArray": [{
					"plateImage": "http://openapi-dev.xxx.xin/openydt/files/images/181022190627313669802846-plate-in-nor.jpg?s=6e86acbb",
					"carImage": "http://openapi-dev.xxx.xin/openydt/files/images/181022190627313669802846-body-in-nor.jpg?s=c9717cf1"
				}],
				"recordType": 1,
				"confidence": 100,
				"enterCarType": 1,
				"enterChannelName": "开发入口",
				"carLicenseNumber": "粤J20846",
				"enterType": 1,
				"lastCorrectName": "",
				"parkingCode": "181022190627313669802846",
				"enterChargeGroupCode": "27",
				"enterCarCardNumber": "",
				"enterRecognitionConfidence": 100,
				"lastCorrectLicenseNumber": "",
				"correctConfidence": 0,
				"cmd": "reportCarIn",
				"parkCode": "2KKN885S",
				"enterCarLicenseType": 0,
				"enterCarLogo": 0,
				"enterVipRule": "",
				"isCorrect": 0
			},
			"parkingCode": null,
			"lockKey": "6fb04885a7ff67b6fb75b0b88b91c8ea885e7b30"
		}]

                },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取未接收到的上报记录",
                t_url: this.commonUrls.test+"requestFailData",
                p_url: this.commonUrls.prod+"requestFailData",
                precondition: "上报失败数据产生超过15日后，平台将永久删除相关数据。调用此接口获取此类数据，将提示“数据超过15日，不可获取”。",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段开始时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段开始时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                        { info1: 'dataType', info2: '是', info3: 'Integer', info4: '数据类型 0-reportCarIn(进场上报)、1-reportCarOut出场上报、、2-reportParkBill（账单上报）、3-reportMonthCar（月卡开通续费上报）、4reportAbnormalCar（遥控开闸上报）、5-reportModifyCar（校正车牌上报）、6-reportParkingFee（临停交费上报）、7-reportCarPicture（图片信息上报）、8-reportTicketUseRecord（储值卡扣费流水上报）、9-reportCarOwner（车主信息上报）、10-reportCar（车辆信息上报）、11-reportEquipmentStatus（设备状态信息上报）、12-reportShift（交接班信息上报）、13-reportCarport（车位信息上报）、14-reportPreCarIn（预进场上报）、15-reportPreCarOut（预出场上报）、21-reportBlacklistRecord（黑名单上报）、25-reportAccountLogin（同步账户登陆）、26-alert（告警）、27-reportDailyParkFee（同步日报表数据）、28-reportAuthUserCarInfo（智慧停车用户绑定车牌及变更上报）、29-reportAuthUserInfo（智慧停车注册用户信息上报）、30-reportAuthUserAuthPic（智慧停车用户认证图片上报）、、33-notifyPayInfoWithoutPayOrder（第三方调用ydtw扫码支付接口通知支付账单信息）、34-reportQrCode（扫码机上报扫码信息）、35-reportChannelBindForScan（扫码机上报通道绑定关系信息）' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'data', info2: '是', info3: 'JSONObject', info4: '数据' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '记录唯一标识' },
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/requestFailData.vue